import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import "./index.scss";

import { AiFillHome, AiFillInstagram, AiFillLinkedin } from "react-icons/ai";
import {
  FaBlogger,
  FaFacebook,
  FaGithub,
  FaLaptopCode,
  FaUserAlt,
} from "react-icons/fa";
import { MdPermContactCalendar } from "react-icons/md";
import { RiShieldStarFill } from "react-icons/ri";
import logo from "../../assets/image/Taifur.jpg";
import { toggleSwitch } from "../../feature/navToggle/navSlice";

const Sidebar = () => {
  const toggle = useSelector((state) => state.toggle.toggle);
  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(toggleSwitch());
  };

  return (
    <div className={toggle ? "aside-container asideActive" : "aside-container"}>
      <div className="aside">
        <div className="aside__logo">
          <div className="logo__img">
            <Link to="/" onClick={handleToggle}>
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="logo__text">
            <h2>
              Taifur <span>Islam</span>
            </h2>
          </div>
        </div>
        <div className="aside__main">
          <NavLink to="/" end className="nav-link" onClick={handleToggle}>
            <AiFillHome />
            Home
          </NavLink>
          <NavLink to="/about" className="nav-link" onClick={handleToggle}>
            <FaUserAlt />
            About
          </NavLink>
          <NavLink to="/skill" className="nav-link" onClick={handleToggle}>
            <FaLaptopCode />
            Skill
          </NavLink>
          <NavLink to="/portfolio" className="nav-link" onClick={handleToggle}>
            <RiShieldStarFill />
            Portfolio
          </NavLink>
          <NavLink to="/blog" className="nav-link" onClick={handleToggle}>
            <FaBlogger />
            Blog
          </NavLink>
          <NavLink to="/contact" className="nav-link" onClick={handleToggle}>
            <MdPermContactCalendar />
            Contact
          </NavLink>
        </div>
        <div className="aside__footer">
          <a
            href="https://www.facebook.com/taifurislam.ashraf.33"
            target="_blank"
            rel="noopener noreferrer"
            className="fb-icon"
          >
            <FaFacebook />
          </a>

          <a
            href="https://www.google.com"
            target="_blank"
            rel="noopener noreferrer"
            className="insta-icon"
          >
            <AiFillInstagram />
          </a>

          <a
            href="https://github.com/TaifurIslamAshraf"
            target="_blank"
            rel="noopener noreferrer"
            className="github-icon"
          >
            <FaGithub />
          </a>

          <a
            href="https://www.linkedin.com/in/mdtaifur/"
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-icon"
          >
            <AiFillLinkedin />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
